import data from './data.js';
import page from './page.js';
import reg from './reg.js';
import * as type from './type.js';
import * as dom from './dom.js';
import time from './time.js';

const unit = Object.assign({}, data, page, reg, type, dom, time);
export default unit;
